(function containerTypeCppDefinition() {
    'use strict';
    angular.module('Entities')
        .service('containerTypeCppService', [
            'restUrlBuilder', function containerTypeCppService(restUrlBuilder) {

                var cppBuilder = restUrlBuilder('cpp');

                this.getContainersLD = function getContainersLD(params) {
                    return cppBuilder.all('ContainerTypes')
                        .get({ params: params });
                };

                this.getContainerTypeLDAssociated = function (id) {
                    return cppBuilder.one('OrganizationalUnits', id)
                        .all('ContainerType')
                        .get();
                };

                this.setContainersLD = function setContainersLD(params) {
                    return cppBuilder.one('OrganizationalUnits', params.OrganizationalUnitId)
                        .all('ContainerType')
                        .put(params);
                };
            }
        ]);
})();